import {
    integrityFacts,
    integrityReasons,
    integrityVerdict,
    verdictClass,
    verdictLabel,
} from "../../utils/testIntegrity";

export function IntegrityBadge({ integrity, testId }) {
    const verdict = integrityVerdict(integrity);
    return (
        <span
            className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-semibold ${verdictClass(verdict)}`}
            data-testid={testId}
        >
            {verdictLabel(verdict)}
        </span>
    );
}

export default function IntegrityPanel({ integrity }) {
    if (!integrity || typeof integrity !== "object") return null;
    const verdict = integrityVerdict(integrity);
    const reasons = integrityReasons(integrity);
    return (
        <section className={`rounded-xl border p-4 ${verdictClass(verdict)}`} data-testid="prof-result-integrity-panel">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <h3 className="text-sm font-bold">Честность прохождения: {verdictLabel(verdict)}</h3>
                {integrity.strict ? <span className="text-xs font-semibold">Строгий контроль</span> : null}
            </div>
            {reasons.length ? <p className="mt-1 text-sm">Причины: {reasons.join(", ")}.</p> : null}
            <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1 text-sm md:grid-cols-4">
                {integrityFacts(integrity).map((fact) => (
                    <div key={fact.label}>
                        <dt className="text-xs opacity-70">{fact.label}</dt>
                        <dd className="font-semibold">{fact.value}</dd>
                    </div>
                ))}
            </dl>
            <p className="mt-3 text-xs opacity-70">
                Браузер не может заблокировать экран или увидеть второе устройство (телефон), поэтому это косвенные признаки.
            </p>
        </section>
    );
}
